/* ==========================================================================
   CHOKS — theme.js | JS vanilla modular, sem dependências
   ========================================================================== */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  // Formatação de moeda compatível com TODOS os placeholders do shop.money_format
  // (amount, amount_with_comma_separator, amount_no_decimals, etc.)
  const money = (cents) => {
    if (cents == null || isNaN(cents)) cents = 0;
    const fmt = (window.CHOKS && window.CHOKS.moneyFormat) || 'R$ {{amount_with_comma_separator}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const key = (fmt.match(placeholder) || [null, 'amount_with_comma_separator'])[1];
    const build = (decimals, thousands, decimal) => {
      const n = (Math.round(Number(cents)) / 100).toFixed(decimals).split('.');
      const intPart = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return intPart + (n[1] ? decimal + n[1] : '');
    };
    let value;
    switch (key) {
      case 'amount': value = build(2, ',', '.'); break;
      case 'amount_no_decimals': value = build(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = build(2, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = build(2, "'", '.'); break;
      case 'amount_with_space_separator': value = build(2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = build(0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = build(0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = build(2, ' ', '.'); break;
      default: value = build(2, '.', ','); // padrão pt-BR: 8.990,00
    }
    return fmt.replace(placeholder, value);
  };

  /* ---------- Overlay + scroll lock ---------- */
  const overlay = $('#overlay');
  function lockScroll(on) { document.body.classList.toggle('no-scroll', on); }
  function closeAll() {
    $$('.drawer.is-open').forEach(d => d.classList.remove('is-open'));
    overlay && overlay.classList.remove('is-open');
    lockScroll(false);
  }
  function openDrawer(id) {
    const d = $('#' + id);
    if (!d) return;
    d.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    lockScroll(true);
    const focusable = d.querySelector('button, a, input');
    focusable && focusable.focus();
  }
  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeAll(); }
  });

  /* ---------- Announcement bar rotation ---------- */
  const annTrack = $('.announcement__track');
  if (annTrack && annTrack.children.length > 1) {
    let i = 0;
    const n = annTrack.children.length;
    const speed = parseInt(annTrack.dataset.speed || '4000', 10);
    setInterval(() => {
      i = (i + 1) % n;
      annTrack.style.transform = `translateX(-${i * 100}%)`;
      annTrack.style.transition = 'transform .5s ease';
    }, speed);
  }

  /* ---------- Predictive search ---------- */
  $$('[data-predictive-search]').forEach(wrap => {
    const input = $('input', wrap);
    const panel = $('.predictive', wrap);
    if (!input || !panel) return;
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { panel.classList.remove('is-open'); return; }
      t = setTimeout(() => fetchPredictive(q, panel), 220);
    });
    document.addEventListener('click', e => { if (!wrap.contains(e.target)) panel.classList.remove('is-open'); });
    input.addEventListener('focus', () => { if (panel.innerHTML.trim()) panel.classList.add('is-open'); });
  });

  function fetchPredictive(q, panel) {
    const url = `${window.Shopify ? window.Shopify.routes.root : '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6`;
    fetch(url).then(r => r.json()).then(data => {
      const res = data.resources.results;
      let html = '';
      if (res.queries && res.queries.length) {
        html += '<div class="predictive__group"><h4>Sugestões</h4>';
        res.queries.slice(0, 4).forEach(qr => html += `<a class="predictive__item" href="${qr.url}">${qr.styled_title || qr.title}</a>`);
        html += '</div>';
      }
      if (res.products && res.products.length) {
        html += '<div class="predictive__group"><h4>Produtos</h4>';
        res.products.forEach(p => {
          const img = p.featured_image ? p.featured_image.url : '';
          html += `<a class="predictive__item" href="${p.url}">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}<span>${p.title}<br><strong>${money(p.price)}</strong></span></a>`;
        });
        html += '</div>';
      }
      if (!html) {
        const wa = window.CHOKS && window.CHOKS.whatsapp ? window.CHOKS.whatsapp : '#';
        html = `<div class="predictive__empty"><p>Nenhum produto encontrado.</p><a class="btn btn--whatsapp btn--sm" href="${wa}">Não encontrou? Fale com a Choks no WhatsApp</a></div>`;
      } else {
        html += `<a class="predictive__item" href="${(window.Shopify ? window.Shopify.routes.root : '/')}search?q=${encodeURIComponent(q)}"><strong>Ver todos os resultados →</strong></a>`;
      }
      panel.innerHTML = html;
      panel.classList.add('is-open');
    }).catch(() => {});
  }

  /* ---------- Cart (drawer + ajax) ---------- */
  const cartCountEls = () => $$('[data-cart-count]');

  function refreshCart() {
    return fetch(`${rootUrl()}cart.js`, { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => { renderCart(cart); return cart; })
      .catch(() => {});
  }
  function rootUrl() { return window.Shopify ? window.Shopify.routes.root : '/'; }

  function renderCart(cart) {
    // Só renderiza objetos de carrinho válidos — nunca uma resposta de erro (422/5xx)
    if (!cart || typeof cart.item_count !== 'number' || !Array.isArray(cart.items)) return;
    cartCountEls().forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count ? 'flex' : 'none'; });
    const body = $('#cart-drawer-body');
    const foot = $('#cart-drawer-foot');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = `<div class="cart-empty"><svg class="icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg><p>Seu carrinho está vazio.</p><button class="btn btn--secondary" data-drawer-close>Continuar comprando</button></div>`;
      if (foot) foot.innerHTML = '';
      return;
    }

    const threshold = window.CHOKS && window.CHOKS.freeShipping ? window.CHOKS.freeShipping : 0;
    let freebar = '';
    if (threshold > 0) {
      const pct = Math.min(100, (cart.total_price / threshold) * 100);
      const remaining = threshold - cart.total_price;
      freebar = `<div class="cart-drawer__freebar">${remaining > 0 ? `Faltam <strong>${money(remaining)}</strong> para frete grátis` : '🎉 Você ganhou <strong>frete grátis</strong>!'}<div class="cart-drawer__progress"><span style="width:${pct}%"></span></div></div>`;
    }

    let items = '';
    cart.items.forEach((it, idx) => {
      items += `<div class="cart-item">
        <div class="cart-item__media">${it.image ? `<img src="${it.image}" alt="" loading="lazy">` : ''}</div>
        <div>
          <p class="cart-item__name">${it.product_title}</p>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<span class="cart-item__variant">${it.variant_title}</span>` : ''}
          <div class="qty">
            <button data-qty-change data-key="${it.key}" data-qty="${it.quantity - 1}" aria-label="Diminuir">−</button>
            <input type="text" value="${it.quantity}" readonly aria-label="Quantidade">
            <button data-qty-change data-key="${it.key}" data-qty="${it.quantity + 1}" aria-label="Aumentar">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <strong>${money(it.final_line_price)}</strong>
          <button data-qty-change data-key="${it.key}" data-qty="0" style="display:block;margin-top:8px;font-size:.74rem;color:var(--c-text-soft)">Remover</button>
        </div>
      </div>`;
    });

    body.innerHTML = freebar + items + (cart.upsell || '');
    if (foot) {
      foot.innerHTML = `<div class="cart-drawer__subtotal"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
        <a href="${rootUrl()}checkout" class="btn btn--primary btn--block btn--lg">Finalizar compra</a>
        <button class="btn btn--ghost btn--block" data-drawer-close>Continuar comprando</button>
        <p class="cart-drawer__secure"><svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> Pagamento 100% seguro</p>`;
    }
  }

  document.addEventListener('click', e => {
    const q = e.target.closest('[data-qty-change]');
    if (!q || q.disabled) return; // evita clique duplo durante atualização
    e.preventDefault();
    changeQty(q.dataset.key, parseInt(q.dataset.qty, 10));
  });

  // Atualiza quantidade pelo item.key (preciso) — usa change.js e nunca esvazia em erro
  function changeQty(key, quantity) {
    if (!key) return;
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    const drawer = $('#cart-drawer');
    if (drawer) drawer.querySelectorAll('[data-qty-change]').forEach(b => b.disabled = true);
    fetch(`${rootUrl()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || typeof data.item_count !== 'number') {
          // ex.: quantidade acima do estoque — mantém os itens e avisa
          const msg = (data && data.description) || 'Não foi possível atualizar a quantidade.';
          refreshCart().then(() => showCartError(msg));
          return;
        }
        renderCart(data); // resposta de change.js já é o carrinho completo
      })
      .catch(() => { refreshCart(); }); // re-sincroniza sem perder itens
  }

  function showCartError(msg) {
    const body = $('#cart-drawer-body');
    if (!body) return;
    const old = body.querySelector('.cart-drawer__error');
    if (old) old.remove();
    const div = document.createElement('div');
    div.className = 'cart-drawer__error';
    div.setAttribute('role', 'alert');
    div.textContent = msg;
    body.prepend(div);
    setTimeout(() => div.remove(), 4000);
  }

  // Guarda qual botão disparou o submit (fallback p/ browsers sem e.submitter)
  document.addEventListener('click', e => {
    const sb = e.target.closest('button[type="submit"], input[type="submit"]');
    if (sb && sb.form) sb.form._submitter = sb;
  });

  // Add to cart / Comprar agora (forms com data-product-form)
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const submitter = e.submitter || form._submitter || form.querySelector('[type="submit"]');
    const buyNow = !!(submitter && submitter.hasAttribute('data-buy-now'));
    const original = submitter ? submitter.textContent : '';
    if (submitter) { submitter.textContent = buyNow ? 'Processando...' : 'Adicionando...'; submitter.disabled = true; }
    const restore = () => { if (submitter) { submitter.textContent = original; submitter.disabled = false; } };

    const addCurrent = () => fetch(`${rootUrl()}cart/add.js`, {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
    }).then(r => r.json().then(data => ({ ok: r.ok, data })));

    // "Comprar agora" limpa o carrinho antes, garantindo SÓ o produto/variante atual no checkout.
    // "Adicionar ao carrinho" apenas adiciona e abre o drawer.
    const chain = buyNow
      ? fetch(`${rootUrl()}cart/clear.js`, { method: 'POST', headers: { 'Accept': 'application/json' } }).then(addCurrent)
      : addCurrent();

    chain
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data && data.description ? data.description : 'Não foi possível adicionar este item.');
        if (buyNow) { window.location.href = `${rootUrl()}checkout`; return; } // navega: não restaura o botão
        refreshCart();
        openDrawer('cart-drawer');
        restore();
      })
      .catch(err => { alert(err.message || 'Não foi possível adicionar. Tente novamente.'); restore(); });
  });

  document.addEventListener('click', e => {
    const qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    const id = qa.dataset.quickAdd;
    qa.disabled = true;
    fetch(`${rootUrl()}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(r => r.json()).then(() => { refreshCart(); openDrawer('cart-drawer'); })
      .finally(() => { qa.disabled = false; });
  });

  // initial cart sync
  if ($('#cart-drawer')) refreshCart();

  /* ---------- Product page: variants + gallery ---------- */
  const productForm = $('[data-product-form]');
  if (productForm) {
    // Fonte de verdade: JSON real do produto (product.variants) num <script>, sem escaping frágil
    let variants = [];
    const variantsScript = $('[data-product-variants]', productForm);
    try { variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]'); } catch (e) { variants = []; }

    const optionInputs = $$('input[data-option-position], select[data-option-position]', productForm); // radios e/ou selects
    const idField = $('input[name="id"]', productForm);
    const priceTarget = $('[data-price-target]');
    const stickyPrice = $('[data-sticky-price]');
    const debug = !!(window.CHOKS && window.CHOKS.debug);

    // Normaliza valores p/ comparar opções de forma resiliente a:
    // espaços extras, acentos (NFC×NFD), entidades HTML (&amp;, &quot;...) e caixa.
    const decoder = document.createElement('textarea');
    function normalizeOption(v) {
      if (v == null) return '';
      decoder.innerHTML = String(v);          // decodifica entidades HTML, se houver
      return decoder.value
        .normalize('NFC')                      // unifica representação de acentos (mantém acentos!)
        .replace(/\s+/g, ' ')                  // colapsa espaços internos
        .trim()
        .toLowerCase();                        // case-insensitive (valores de opção são únicos por opção)
    }

    // Lê os valores selecionados na ORDEM REAL das opções Shopify (position 1 → índice 0)
    function selectedOptions() {
      const opts = [];
      optionInputs.forEach(i => {
        const pos = parseInt(i.dataset.optionPosition, 10); // 1, 2 ou 3
        if (!pos) return;
        if (i.tagName === 'SELECT') opts[pos - 1] = i.value;
        else if (i.checked) opts[pos - 1] = i.value;
      });
      return opts;
    }

    // Match pela estrutura NATIVA do Shopify: variant.option1/option2/option3 por posição.
    // Não depende do nome da opção ("Cor"/"Tamanho"/"Voltagem") nem do texto visual do label.
    function findVariant(selected) {
      return variants.find(v =>
        normalizeOption(v.option1) === normalizeOption(selected[0]) &&
        normalizeOption(v.option2) === normalizeOption(selected[1]) &&
        normalizeOption(v.option3) === normalizeOption(selected[2])
      );
    }

    function updateGalleryImage(match) {
      if (!match.featured_image || !match.featured_image.src) return;
      const gallery = productForm.closest('.product-layout') || document;
      const mainImg = gallery.querySelector('[data-gallery-main] img');
      const rawSrc = match.featured_image.src.replace(/^\/\//, 'https://');
      const cdnSrc = rawSrc.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2');
      if (mainImg && mainImg.src !== cdnSrc) { mainImg.src = cdnSrc; mainImg.alt = match.featured_image.alt || ''; }
      const stripDim = url => (url || '').replace(/(_\d+x\d*)+(\.[a-z]+)/i, '$2').split('?')[0].split('/').pop();
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(t => {
        t.classList.toggle('is-active', stripDim(t.dataset.full) === stripDim(rawSrc));
      });
    }

    function updateVariant() {
      if (!variants.length) return;
      const selected = selectedOptions();
      const match = optionInputs.length ? findVariant(selected) : variants[0];
      const submits = productForm.querySelectorAll('[type="submit"]');

      // Sem correspondência: só aqui marcamos indisponível por falha de matching
      if (!match) {
        if (debug) {
          console.warn('[CHOKS] Nenhuma variante casou com a seleção.', {
            selecionado: selected,
            opcoesDasVariantes: variants.map(v => v.options)
          });
        }
        if (idField) idField.value = '';
        submits.forEach(btn => { btn.disabled = true; btn.textContent = 'Indisponível'; });
        return;
      }

      // Atualiza o id REAL da variante (usado por Comprar agora, Adicionar e sticky)
      if (idField) idField.value = match.id;

      // Mantém ?variant=ID na URL (padrão Shopify)
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      if (priceTarget && match.price != null) priceTarget.innerHTML = money(match.price);
      if (stickyPrice && match.price != null) stickyPrice.innerHTML = money(match.price);

      // Disponibilidade real da variante. Trata só `available === false` como esgotado;
      // qualquer outro caso (true/ausente) mantém os botões ativos — evita falso "Indisponível".
      const available = match.available !== false;
      submits.forEach(btn => {
        btn.disabled = !available;
        btn.textContent = available ? (btn.dataset.label || 'Adicionar ao carrinho') : 'Indisponível';
      });

      updateGalleryImage(match);
    }

    optionInputs.forEach(i => i.addEventListener('change', updateVariant));

    // Ao carregar com ?variant=ID, inicia essa variante selecionada
    (function initFromUrl() {
      let vid;
      try { vid = new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
      if (!vid) return;
      const target = variants.find(v => String(v.id) === String(vid));
      if (!target || !Array.isArray(target.options)) return;
      optionInputs.forEach(i => {
        const pos = parseInt(i.dataset.optionPosition, 10);
        const val = target.options[pos - 1];
        if (i.tagName === 'SELECT') i.value = val;
        else i.checked = (normalizeOption(i.value) === normalizeOption(val));
      });
      updateVariant();
    })();
  }

  // Gallery thumbnails
  $$('[data-gallery]').forEach(g => {
    const main = $('[data-gallery-main] img', g);
    $$('[data-gallery-thumb]', g).forEach(thumb => {
      thumb.addEventListener('click', () => {
        const full = thumb.dataset.full;
        if (main && full) main.src = full;
        $$('[data-gallery-thumb]', g).forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  const sticky = $('.sticky-atc');
  const atcAnchor = $('[data-atc-anchor]');
  if (sticky && atcAnchor && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => sticky.classList.toggle('is-visible', !en.isIntersecting));
    }, { rootMargin: '0px 0px -40% 0px' });
    io.observe(atcAnchor);
  }

  // Sticky "Comprar" (mobile) → dispara o fluxo de Comprar agora respeitando variante/qtd
  const stickyBuy = $('[data-sticky-buy]');
  if (stickyBuy) {
    stickyBuy.addEventListener('click', e => {
      const form = $('[data-product-form]');
      if (!form) return; // sem form: mantém o href de fallback (#ProductBuyBox)
      const primary = form.querySelector('[data-buy-now]');
      if (!primary || primary.disabled) return; // indisponível: não faz nada
      e.preventDefault();
      primary.click(); // submete o form em modo Comprar agora
    });
  }

  /* ---------- Flash offer timer ---------- */
  $$('[data-timer]').forEach(el => {
    const end = new Date(el.dataset.timer).getTime();
    if (isNaN(end)) return;
    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) { el.textContent = 'Oferta encerrada'; return; }
      const d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5),
            m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
      el.innerHTML = `<span class="flash__time">${d}d</span><span class="flash__time">${String(h).padStart(2, '0')}h</span><span class="flash__time">${String(m).padStart(2, '0')}m</span><span class="flash__time">${String(s).padStart(2, '0')}s</span>`;
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Collection: sort ---------- */
  $$('[data-sort]').forEach(sortSelect => {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Collection: filtros (auto-submit) ---------- */
  $$('[data-filters-form]').forEach(form => {
    function applyFilters() {
      const params = new URLSearchParams();
      // ordenação atual
      const sort = $('[data-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      // checkboxes marcados
      $$('input[type="checkbox"]:checked', form).forEach(cb => params.append(cb.name, cb.value));
      // faixa de preço
      $$('[data-price-input]', form).forEach(inp => { if (inp.value) params.set(inp.name, inp.value); });
      const base = window.location.pathname;
      window.location.href = params.toString() ? base + '?' + params.toString() : base;
    }
    $$('input[data-auto-submit]', form).forEach(cb => cb.addEventListener('change', applyFilters));
    form.addEventListener('submit', e => { e.preventDefault(); applyFilters(); });
  });

  /* ---------- Recommendations (Section Rendering API) ---------- */
  const recoBox = $('[data-recommendations]');
  if (recoBox && recoBox.dataset.url) {
    fetch(recoBox.dataset.url)
      .then(r => r.text())
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const grid = tmp.querySelector('.product-grid');
        if (grid && grid.children.length) {
          recoBox.innerHTML = '<h2 class="section-title">Você também pode gostar</h2>';
          recoBox.appendChild(grid);
        }
      })
      .catch(() => {});
  }

  /* ---------- Recently viewed: armazena histórico (render server-side opcional) ---------- */
  try {
    const pid = document.body.dataset.productId;
    if (pid) {
      let seen = JSON.parse(localStorage.getItem('choks_recent') || '[]');
      seen = [pid, ...seen.filter(x => x !== pid)].slice(0, 8);
      localStorage.setItem('choks_recent', JSON.stringify(seen));
    }
  } catch (e) {}

  /* ---------- Cart page: qty steppers ---------- */
  const cartPageForm = $('[data-cart-page-form]');
  if (cartPageForm) {
    $$('[data-cart-plus]', cartPageForm).forEach(btn => btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('[data-cart-qty]');
      input.value = parseInt(input.value || '0', 10) + 1;
      cartPageForm.submit();
    }));
    $$('[data-cart-minus]', cartPageForm).forEach(btn => btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('[data-cart-qty]');
      input.value = Math.max(0, parseInt(input.value || '0', 10) - 1);
      cartPageForm.submit();
    }));
    $$('[data-cart-qty]', cartPageForm).forEach(input => input.addEventListener('change', () => cartPageForm.submit()));
  }

  /* ---------- Product cards: swatches de cor (preview de imagem por variante) ----------
     Apenas visualização: troca a imagem do card e o link p/ ?variant=ID.
     Estado 100% escopado por card (card.querySelector) — nunca seletores globais.
     NÃO adiciona ao carrinho e NÃO interfere no variant picker da página de produto. */
  document.addEventListener('click', e => {
    const swatch = e.target.closest('[data-card-swatches] .card__swatch, [data-card-swatches] .moto-card__color');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation(); // o clique na bolinha não abre o produto nem borbulha p/ o card

    const card = swatch.closest('.card, .moto-card');
    if (!card) return;
    const group = swatch.closest('[data-card-swatches]');

    // marca a swatch ativa SOMENTE dentro deste card (não global)
    (group ? $$('.card__swatch, .moto-card__color', group) : []).forEach(s => {
      s.classList.remove('is-active');
      s.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');

    // troca a imagem APENAS deste card, se a variante tiver imagem própria; senão mantém a atual
    const img = card.querySelector('.card__media img:not(.card__img--secondary), .moto-card__media img');
    const newSrc = swatch.dataset.variantImage;
    if (img && newSrc) {
      img.src = newSrc;
      img.removeAttribute('srcset');
      img.alt = swatch.dataset.colorName || img.alt;
    }

    // marca o card como "cor escolhida": o CSS para de revelar a 2ª imagem no hover,
    // assim o hover/touch não desfaz mais a cor selecionada. Estado fica no próprio card.
    card.classList.add('has-active-swatch');
    card.dataset.selectedVariantId = swatch.dataset.variantId || '';

    // aponta os links DESTE card para a variante selecionada (?variant=ID)
    const vurl = swatch.dataset.variantUrl;
    if (vurl) $$('a[href]', card).forEach(a => {
      if (a.classList.contains('card__media') || a.classList.contains('moto-card__media') || a.closest('.card__name')) {
        a.href = vurl;
      }
    });
  });

})();
